var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { AntdIcon } from '../components/antdIcons';
function genericResolveProps(_a, Component, prefix) {
    var render = _a.render, _icon = _a.icon, _b = _a.type, type = _b === void 0 ? 'success' : _b, props = __rest(_a, ["render", "icon", "type"]);
    var icon = _icon || (React.createElement("div", { className: "icon-".concat(prefix, " icon-").concat(type) },
        React.createElement(AntdIcon, { isFilled: prefix === 'message', type: type })));
    var _render = render ? (render(__assign(__assign({}, props), { type: type, icon: icon, message: props.message }))) : (React.createElement(Component, __assign({ type: type, icon: icon }, props)));
    return __assign(__assign({ type: type, icon: icon }, props), { content: _render });
}
export default genericResolveProps;
